/**
 * scrollToTop — smoothly scrolls the page to the top.
 *
 * Use this in any save handler that toggles edit → view mode on the same URL
 */
export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
